// removed by extract-text-webpack-plugin
module.exports = {"confirm-modal":"confirm-modal","modal-body":"modal-body","paragraph":"paragraph","button-cancel":"button-cancel","button-confirm":"button-confirm","modal-item":"modal-item"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/confirm-modal/confirm-modal.style.sass
// module id = axi+
// module chunks = 0